import { APIs } from 'src/models/apis';
import { QueryKey } from 'src/models/query';
import { Videos } from 'src/graphql/schema.graphql';
import { QueryDefinition } from 'src/utils/reactQuery';
import { queryCommonOptions } from 'src/utils/queryCommonOptions';
import { videoDetailsGqlQuery } from 'src/modules/videos/graphql/videos-details.query';
import { Variables } from 'src/utils/gql/query';

export const videoQueryFactory = (
  apis: APIs,
  filters: Variables<typeof videoDetailsGqlQuery>['filters'],
): QueryDefinition<Videos | null> => ({
  ...queryCommonOptions.longStale,
  queryKey: [...QueryKey.Video, filters],
  queryFn: async () => {
    const directus = await apis.directus();

    return directus
      .query(videoDetailsGqlQuery, { filters })
      .then((a) => a.videos[0]);
  },
});

export const videoQueryByIdFactory = (
  apis: APIs,
  videoId: Videos['id'],
): QueryDefinition<Videos | null> =>
  videoQueryFactory(apis, {
    id: {
      _eq: videoId,
    },
  });

export const videoQueryBySlugFactory = (
  apis: APIs,
  slug: Videos['id'],
): QueryDefinition<Videos | null> =>
  videoQueryFactory(apis, {
    slug: {
      _eq: slug,
    },
  });

const UUIDRegExp =
  /^[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}$/;

export const videoQueryByIdOrSlugFactory = (
  apis: APIs,
  videoIdOrSlug: Videos['id'] | Videos['slug'],
): QueryDefinition<Videos | null> =>
  UUIDRegExp.test(videoIdOrSlug)
    ? videoQueryByIdFactory(apis, videoIdOrSlug)
    : videoQueryBySlugFactory(apis, videoIdOrSlug);
